// Simple pass-through reducer for breadcrumbs
// Breadcrumbs are set via server-side __INITIAL_STATE__ and don't need actions
export default function breadcrumbsReducer(state = { items: [] }) {
  return state;
}
